<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>{{ $t('rechargeOrder.queryCondition') }}</span>
      </div>
      <el-form :inline="true" :model="rechargeOrderInfo.conditions" class="query-form">
        <el-form-item>
          <el-input 
            v-model="rechargeOrderInfo.conditions.orderNo"
            :placeholder="$t('rechargeOrder.orderNoPlaceholder')" 
            clearable 
            style="width: 200px" />
        </el-form-item>
        <el-form-item>
          <el-input 
            v-model="rechargeOrderInfo.conditions.userPhone"
            :placeholder="$t('rechargeOrder.userPhonePlaceholder')" 
            clearable 
            style="width: 150px" />
        </el-form-item>
        <el-form-item>
          <el-select 
            v-model="rechargeOrderInfo.conditions.rechargeType"
            :placeholder="$t('rechargeOrder.rechargeTypePlaceholder')" 
            clearable
            style="width: 150px">
            <el-option :label="$t('common.all')" value="" />
            <el-option v-for="(item, index) in rechargeTypeOptions" :key="index" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select 
            v-model="rechargeOrderInfo.conditions.payStatus"
            :placeholder="$t('rechargeOrder.payStatusPlaceholder')" 
            clearable
            style="width: 150px">
            <el-option :label="$t('common.all')" value="" />
            <el-option :label="$t('rechargeOrder.payStatus0')" value="0" />
            <el-option :label="$t('rechargeOrder.payStatus1')" value="1" />
            <el-option :label="$t('rechargeOrder.payStatus2')" value="2" />
            <el-option :label="$t('rechargeOrder.payStatus3')" value="3" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select 
            v-model="rechargeOrderInfo.conditions.rechargeStatus"
            :placeholder="$t('rechargeOrder.rechargeStatusPlaceholder')" 
            clearable
            style="width: 150px">
            <el-option :label="$t('common.all')" value="" />
            <el-option :label="$t('rechargeOrder.rechargeStatus0')" value="0" />
            <el-option :label="$t('rechargeOrder.rechargeStatus1')" value="1" />
            <el-option :label="$t('rechargeOrder.rechargeStatus2')" value="2" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select 
            v-model="rechargeOrderInfo.conditions.fastCharge"
            :placeholder="$t('rechargeOrder.fastChargePlaceholder')" 
            clearable
            style="width: 120px">
            <el-option :label="$t('common.all')" value="" />
            <el-option :label="$t('rechargeOrder.fastCharge1')" value="1" />
            <el-option :label="$t('rechargeOrder.fastCharge2')" value="2" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="rechargeOrderInfo.conditions.startPayTime"
            type="date"
            :placeholder="$t('rechargeOrder.startPayTimePlaceholder')"
            clearable
            style="width: 150px"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="rechargeOrderInfo.conditions.endPayTime"
            type="date"
            :placeholder="$t('rechargeOrder.endPayTimePlaceholder')"
            clearable
            style="width: 150px"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="_queryRechargeOrderMethod">
            {{ $t('rechargeOrder.query') }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="box-card">
      <div slot="header" class="clearfix flex justify-between">
        <div>
          <span>{{ $t('rechargeOrder.title') }}</span>
          <el-button style="margin-left: 10px" type="primary" @click="_openImportModal">
            <i class="el-icon-upload"></i>{{ $t('rechargeOrder.import') }}
          </el-button>
        </div>
        <el-button type="text" @click="_exportRechargeOrder">
          <i class="el-icon-download"></i>{{ $t('rechargeOrder.export') }}
        </el-button>
      </div>
      <el-table :data="rechargeOrderInfo.rechargeOrders" border style="width: 100%">
        <el-table-column prop="id" :label="$t('rechargeOrder.id')" align="center" width="100" />
        <el-table-column prop="orderNo" :label="$t('rechargeOrder.orderNo')" align="center" width="150" />
        <el-table-column prop="rechargeType" :label="$t('rechargeOrder.rechargeType')" align="center" width="100">
          <template slot-scope="scope">
            {{ getRechargeTypeLabel(scope.row.rechargeType) }}
          </template>
        </el-table-column>
        <el-table-column prop="phone" :label="$t('rechargeOrder.phone')" align="center" width="100" />
        <el-table-column prop="phoneName" :label="$t('rechargeOrder.phoneName')" align="center" width="100" />
        <el-table-column prop="electricUnit" :label="$t('rechargeOrder.electricUnit')" align="center" width="120" />
        <el-table-column prop="electricAddr" :label="$t('rechargeOrder.electricAddr')" align="center" width="150" />
        <el-table-column prop="electricAccount" :label="$t('rechargeOrder.electricAccount')" align="center" width="120" />
        <el-table-column prop="electricOwner" :label="$t('rechargeOrder.electricOwner')" align="center" width="100" />
        <el-table-column prop="fastCharge" :label="$t('rechargeOrder.fastCharge')" align="center" width="100">
          <template slot-scope="scope">
            {{ getFastChargeLabel(scope.row.fastCharge) }}
          </template>
        </el-table-column>
        <el-table-column prop="payAmount" :label="$t('rechargeOrder.payAmount')" align="center" width="100" />
        <el-table-column prop="faceAmount" :label="$t('rechargeOrder.faceAmount')" align="center" width="100" />
        <el-table-column prop="deductAmount" :label="$t('rechargeOrder.deductAmount')" align="center" width="100" />
        <el-table-column prop="paySn" :label="$t('rechargeOrder.paySn')" align="center" width="150" />
        <el-table-column prop="payStatus" :label="$t('rechargeOrder.payStatus')" align="center" width="100">
          <template slot-scope="scope">
            {{ getPayStatusLabel(scope.row.payStatus) }}
          </template>
        </el-table-column>
        <el-table-column prop="rechargeStatus" :label="$t('rechargeOrder.rechargeStatus')" align="center" width="100">
          <template slot-scope="scope">
            {{ getRechargeStatusLabel(scope.row.rechargeStatus) }}
          </template>
        </el-table-column>
       <!--  <el-table-column prop="thirdOrderNo" :label="$t('rechargeOrder.thirdOrderNo')" align="center" width="150" /> -->
       <!--  <el-table-column prop="remark" :label="$t('rechargeOrder.remark')" align="center" /> -->
        <el-table-column prop="createTime" :label="$t('rechargeOrder.createTime')" align="center" width="150" />
        <el-table-column prop="payTime" :label="$t('rechargeOrder.payTime')" align="center" width="150" />
        <el-table-column prop="finishTime" :label="$t('rechargeOrder.finishTime')" align="center" width="150" />
      </el-table>

      <el-pagination 
        @current-change="handleCurrentChange" 
        :current-page="rechargeOrderInfo.conditions.page"
        :page-size="rechargeOrderInfo.conditions.row" 
        layout="total, prev, pager, next"
        :total="rechargeOrderInfo.total" 
        class="pagination" />
    </el-card>

    <el-dialog :title="$t('rechargeOrder.import')" :visible.sync="importDialogVisible" width="500px">
      <el-form label-position="left" label-width="100px">
        <el-form-item label="选择文件">
          <el-upload class="upload-demo" ref="upload" action="#" :auto-upload="false" :on-change="_getExcelTemplate"
            :file-list="importFileList" accept=".xls,.xlsx">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            <div slot="tip" class="el-upload__tip">
              {{ rechargeOrderInfo.excelTemplate === '' ? '必填，请选择数据文件' : rechargeOrderInfo.excelTemplate.name }}
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="rechargeOrderInfo.importRemark" placeholder="请填写备注信息" :rows="3"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="_closeImportModal">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="_importRechargeOrder">{{ $t('rechargeOrder.import') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listRechargeOrders, exportRechargeOrder as exportRechargeOrderApi, importRechargeOrder as importRechargeOrderApi } from '@/api/order/rechargeOrderApi'

export default {
  name: 'RechargeOrder',
  data() {
    return {
      rechargeTypeOptions: [
        { label: this.$t('rechargeOrder.PHONE'), value: 'PHONE' },
        { label: this.$t('rechargeOrder.ELECTRIC'), value: 'ELECTRIC' },
        { label: this.$t('rechargeOrder.WATER'), value: 'WATER' },
        { label: this.$t('rechargeOrder.GAS'), value: 'GAS' },
        { label: this.$t('rechargeOrder.PROPERTY'), value: 'PROPERTY' }
      ],
      rechargeOrderInfo: {
        rechargeOrders: [],
        total: 0,
        excelTemplate: '',
        importRemark: '',
        conditions: {
          orderNo: '',
          userPhone: '',
          rechargeType: '',
          payStatus: '',
          rechargeStatus: '',
          fastCharge: '',
          startPayTime: '',
          endPayTime: '',
          page: 1,
          row: 10
        }
      },
      importFileList: [],
      importDialogVisible: false
    }
  },
  created() {
    this._listRechargeOrders(1, 10)
  },
  methods: {
    async _listRechargeOrders(page, rows) {
      this.rechargeOrderInfo.conditions.page = page
      this.rechargeOrderInfo.conditions.row = rows

      try {
        const res = await listRechargeOrders(this.rechargeOrderInfo.conditions)
        if (res.code === 0 || res.code === '0') {
          this.rechargeOrderInfo.total = res.total
          this.rechargeOrderInfo.rechargeOrders = res.data || []
        }
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _queryRechargeOrderMethod() {
      this._listRechargeOrders(1, 10)
    },
    handleCurrentChange(val) {
      this._listRechargeOrders(val, this.rechargeOrderInfo.conditions.row)
    },
    getRechargeTypeLabel(type) {
      const option = this.rechargeTypeOptions.find(item => item.value === type)
      return option ? option.label : type
    },
    getPayStatusLabel(status) {
      const statusMap = {
        '0': this.$t('rechargeOrder.payStatus0'),
        '1': this.$t('rechargeOrder.payStatus1'),
        '2': this.$t('rechargeOrder.payStatus2'),
        '3': this.$t('rechargeOrder.payStatus3')
      }
      return statusMap[status] || status
    },
    getRechargeStatusLabel(status) {
      const statusMap = {
        '0': this.$t('rechargeOrder.rechargeStatus0'),
        '1': this.$t('rechargeOrder.rechargeStatus1'),
        '2': this.$t('rechargeOrder.rechargeStatus2'),
        '3': this.$t('rechargeOrder.rechargeStatus3'),
        '4': this.$t('rechargeOrder.rechargeStatus4')
      }
      return statusMap[status] || status
    },
    getFastChargeLabel(type) {
      const typeMap = {
        '1': this.$t('rechargeOrder.fastCharge1'),
        '2': this.$t('rechargeOrder.fastCharge2')
      }
      return typeMap[type] || type
    },
    async _exportRechargeOrder() {
      try {
        const params = { ...this.rechargeOrderInfo.conditions }
        params.pagePath = 'rechargeOrder'
        params.shopId = '-1'
        params.fileName = '充值订单'
        
        await exportRechargeOrderApi(params)
        this.$message.success('导出任务已提交，请前往下载中心查看')
        this.$router.push('/pages/property/downloadTempFile?tab=下载中心')
      } catch (err) {
        console.error('导出充值订单失败', err)
        this.$message.error('导出任务提交失败')
      }
    },
    _openDownloadRechargeOrderTemplate() {
      window.open('/import/rechargeOrder.xlsx')
    },
    _openImportModal() {
      this.importDialogVisible = true
    },
    _closeImportModal() {
      this.importDialogVisible = false
      this.rechargeOrderInfo.excelTemplate = ''
      this.importFileList = []
    },
    _getExcelTemplate(file) {
      this.rechargeOrderInfo.excelTemplate = file.raw
    },
    async _importRechargeOrder() {
      if (!this.rechargeOrderInfo.excelTemplate) {
        this.$message.error('文件不能为空')
        return
      }

      const fileName = this.rechargeOrderInfo.excelTemplate.name
      const fileType = fileName.split('.')[1]
      if (!this._checkFileType(fileType)) {
        this.$message.error('不是有效的Excel格式')
        return
      }

      if (!this._checkFileSize(this.rechargeOrderInfo.excelTemplate.size)) {
        this.$message.error('Excel文件大小不能超过2M')
        return
      }

      const formData = new FormData()
      formData.append('uploadFile', this.rechargeOrderInfo.excelTemplate)
      formData.append('shopId', '-1')
      formData.append('importAdapt', 'importRechargeOrder')

      try {
        const res = await importRechargeOrderApi(formData)
        console.log(res)
        this.$message.success('处理成功')
        this._listRechargeOrders(1, 10)
        this._closeImportModal()
      } catch (error) {
        this.$message.error(error || '导入失败')
      }
    },
    _checkFileType(fileType) {
      const acceptTypes = ['xls', 'xlsx']
      return acceptTypes.includes(fileType)
    },
    _checkFileSize(fileSize) {
      const MAX_SIZE = 2 * 1024 * 1024
      return fileSize <= MAX_SIZE
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
.query-form {
  text-align: left;
}
.pagination {
  margin-top: 20px;
  text-align: right;
}
.card-header-right {
  float: right;
  padding: 3px 0;
}
.flex {
  display: flex;
}
.justify-between {
  justify-content: space-between;
}
</style>